import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {AppComponent} from '../../app.component';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  url: string;
  pageUrl:string;
  userID:string;
  showMsg: boolean;
  Msg: string;
  status: number;
  class:string;

  constructor(private router: Router, private http: HttpClient) {
    this.url = AppComponent.baseURL;
  }

  ngOnInit() {
  }

  goToPage(): void {
    this.router.navigate(['/login']);
  }

  onClickSubmit(formData)
  {
    this.http.get(
        this.url + 'Login/RecoverPassword?Code='+ formData.usercode +'&LoginID=' + formData.username + '&EmailID=' + formData.emailId)
        .subscribe( (data: Result) => {
          this.Msg = data.Message;
          this.showMsg = true;
          this.status = data.Status;
          if (data.Status != 200) {
            this.class = "Err";
          } else{
            this.class = ""; }
         },
         (error) => {
           this.Msg = "Internal Server Error.";
           this.showMsg = true;
          }
      );
  }

}

export interface Result {
  Status: number;
  Message: string;
}
